export default __webpack_public_path__ + "static/085-2c7005b4107c4729ff5fc17149941cc6.jpg";